import { ConfAlertsSubscription } from "../../graphql/generated/operations";

/**
 * @param {ConfAlertsSubscription | undefined} data
 * @returns {any[] | undefined}
 */
export const formatter = (data) => data?.alertSubscriptions;
